/* eslint-env browser */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import {
	Row, Col, Button, Progress,
} from 'reactstrap';
import { Transition, config } from 'react-spring';
import UserProfileForm from './UserProfileForm.jsx';
import './App.css';
import './loader.css';

const STATIC_DATA_URL = './question_data.json';
const ACTIVITY_DATA_URL = 'https://script.googleusercontent.com/macros/echo?user_content_key=C38EeYazyOOLvhJOR6uBeWxPtSE-JTgqf--z0iwxGXK5-1_RZNQhkp0sAWufBo9wxYqqNiJbRAgRE48k80DU6bJYmPeeBuqgm5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnLY_F-e0amM59Vb38DofqRw8ji0IyF4nj7vWrJ7P6rSHxIjWUWVWuPDaCWbN12qfJfRuxRV7fUnU&lib=MU9aq9ZZcx2n_1Jz4SE1K5HDj4vKGeTj5';

const Loader = () => (
	<div className="loader text-center">
		<div className="spinner">
			<div className="dot1" />
			<div className="dot2" />
		</div>
		<h2>Loading Activityper...</h2>
	</div>
);

const LikertQ = ({
	questionText,
	qid,
	onClick,
	value,
}) => (
	<Transition
		from={{ position: 'absolute', opacity: 0 }}
		enter={{ opacity: 1 }}
		leave={{ opacity: 0 }}
		config={config.slow}
	>
		{ ({ opacity }) => (
			<div className="question" style={{ opacity }}>
				<p className="question-text">{questionText}</p>
				<div className="question-buttons">
					<div className="row">
						<div className="col-md-1" />
						<div className="col-md-2">
							<Button color="primary" onClick={() => setTimeout(() => onClick(qid, -2), 300)} active={value === -2}>Strongly Disagree</Button>
						</div>
						<div className="col-md-2">
							<Button color="primary" onClick={() => setTimeout(() => onClick(qid, -1), 300)} active={value === -1}>Disagree</Button>
						</div>
						<div className="col-md-2">
							<Button color="primary" onClick={() => setTimeout(() => onClick(qid, 0), 300)} active={value === 0}>Neutral</Button>
						</div>
						<div className="col-md-2">
							<Button color="primary" onClick={() => setTimeout(() => onClick(qid, 1), 300)} active={value === 1}>Agree</Button>
						</div>
						<div className="col-md-2">
							<Button color="primary" onClick={() => setTimeout(() => onClick(qid, 2), 300)} active={value === 2}>Strongly Agree</Button>
						</div>
						<div className="col-md-1" />
					</div>
				</div>
			</div>
		)}
	</Transition>
);

LikertQ.propTypes = {
	questionText: PropTypes.string.isRequired,
	qid: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	value: PropTypes.number,
};

LikertQ.defaultProps = {
	value: undefined,
};

const StepProgress = ({ current, total }) => (
	<div className="step-progress">
		<Progress value={(current / total) * 100} />
		<p>
			{`${current} of ${total}`}
		</p>
	</div>
);

StepProgress.propTypes = {
	current: PropTypes.number.isRequired,
	total: PropTypes.number.isRequired,
};

const FilteredActivities = ({ data, type }) => (
	<div>
		<h2>Active Cambridge Members You Might Be Interested In</h2>
		<table>
			<thead>
				<tr>
					<th>Member</th>
					<th className="d-none d-sm-table-cell">Description</th>
					<th>Contact Info</th>
				</tr>
			</thead>
			<tbody>
				{ data.filter(a => a.activitype.toLowerCase() === type.toLowerCase()).map(a => (
					<tr>
						<td><a target={`_new${Math.floor(Math.random() * 1000000)}`} href={a.website}>{a.orgName}</a></td>
						<td className="d-none d-sm-table-cell">{a.description}</td>
						<td>
							{a.firstName} {a.lastName}<br />
							<a href={`mailto:${a.emailAddress}`}>{a.emailAddress}</a>
						</td>
					</tr>
				)) }
			</tbody>
		</table>
	</div>
);

FilteredActivities.propTypes = {
	data: PropTypes.array.isRequired,
	type: PropTypes.string.isRequired,
};


class App extends Component {
	constructor(props) {
		super(props);

		/* eslint-disable react/no-unused-state */
		this.state = {
			questionData: null,
			formData: {},
			currentStep: 0,
		};
		/* eslint-enable react/no-unused-state */

		this.updateFormData = this.updateFormData.bind(this);
		this.calculateActivitype = this.calculateActivitype.bind(this);
	}

	componentDidMount() {
		this.fetchCachedData('questionData', STATIC_DATA_URL);
		this.fetchCachedData('activityData', ACTIVITY_DATA_URL);
	}

	reset() {
		this.setState({
			formData: {},
			currentStep: 0,
		});
	}

	fetchCachedData(stateVar, url) {
		const cacheVar = `${stateVar}Cache`;
		const cache = JSON.parse(localStorage.getItem(cacheVar));
		const timestamp = new Date();

		// look for refreshData in querystring
		const options = qs.parse(window.location.search, { ignoreQueryPrefix: true });

		// only fetch data once per hour
		if (
			options.refreshData
			|| !cache
			|| timestamp.getTime() - cache.lastSaved > 3600000
		) {
			window.fetch(url)
				.then(response => response.json())
				.then((data) => {
					console.log(data);
					this.setState({ [stateVar]: data }, () => {
						localStorage.setItem(cacheVar, JSON.stringify({
							data,
							lastSaved: timestamp.getTime(),
						}));
					});
				});
		} else {
			this.setState({
				[stateVar]: cache.data,
			});
		}
	}

	updateFormData(id, value) {
		const { formData } = this.state;
		formData[id] = value;

		if (this.allAnswered()) {
			this.calculateActivitype();
		}

		this.setState({ formData });
	}

	allAnswered() {
		const { formData, questionData } = this.state;

		// check to see all questions have been answered
		return questionData.questions.every(q => (formData[q.id] >= -2 && formData[q.id] <= 2));
	}

	calculateActivitype() {
		const { questionData, formData } = this.state;

		// using form choices, calculate and return the ActiviTYPE
		let rewardCount = 0;
		let socialCount = 0;

		questionData.questions.forEach((q) => {
			if (q.category === 'social') {
				socialCount += formData[q.id] * q.factor;
			} else { // === 'reward'
				rewardCount += formData[q.id] * q.factor;
			}
		});

		const rewardType = rewardCount < 0 ? 'intrinsic' : 'extrinsic';
		const socialType = socialCount < 0 ? 'solo' : 'social';

		// Intrinsic-Solo: Earth
		// Intrinsic-Social: Wind
		// Extrinsic-Solo: Water
		// Extrinsic-Social: Fire
		let activitype;
		if (rewardType === 'intrinsic' && socialType === 'solo') {
			activitype = 'earth';
		} else if (rewardType === 'intrinsic' && socialType === 'social') {
			activitype = 'wind';
		} else if (rewardType === 'extrinsic' && socialType === 'solo') {
			activitype = 'water';
		} else if (rewardType === 'extrinsic' && socialType === 'social') {
			activitype = 'fire';
		}

		this.setState({ activitype });
	}

	steps() {
		const { questionData } = this.state;
		const ids = questionData.questions.map(q => q.id);
		return ['welcome', ...ids, 'results'];
	}

	goNextStep() {
		const { currentStep } = this.state;
		const steps = this.steps();
		const nextStep = currentStep < steps.length - 1 ? currentStep + 1 : currentStep;

		this.setState({ currentStep: nextStep });
	}

	goPrevStep() {
		const { currentStep } = this.state;
		const nextStep = currentStep > 0 ? currentStep - 1 : currentStep;

		this.setState({ currentStep: nextStep });
	}

	renderQuestion(question) {
		const { questionData, formData } = this.state;

		// get question info
		const q = questionData.questions.find(i => i.id === question);

		return (
			<div>
				<LikertQ
					key={q.id}
					qid={q.id}
					questionText={q.question}
					value={formData[q.id]}
					onClick={(id, v) => { this.updateFormData(id, v); this.goNextStep(); }}
				/>

				<div className="nav-buttons">
					<Button color="light" onClick={() => this.goPrevStep()}>Go Back</Button>&nbsp;
					{/*
					<Button
						color="primary"
						onClick={() => this.goNextStep()}
						disabled={formData[q.id] === undefined}
					>
						Next
					</Button>
					*/}
				</div>
			</div>
		);
	}

	renderResults() {
		const { questionData, activityData, activitype } = this.state;

		const typeData = questionData.activitypes[activitype];
		return (
			<div className="results">
				<Row>
					<Col className="align-left">
						<h1>You are <u>{typeData.title.toUpperCase()}</u> type!</h1>
					</Col>
					<Col sm="3" className="text-center">
						<Button className="mt-2" color="primary" onClick={() => this.reset()}>Start Over</Button>
					</Col>
				</Row>
				<Row>
					<Col sm="4" className="text-center">
						<img src={`images/${activitype}.png`} alt={typeData.title} />
					</Col>
					<Col>
						<div>
							<p>{typeData.description}</p>
							<p>
								<strong>Suggested Activities:</strong>&nbsp;
								{typeData.activities}
							</p>
						</div>
					</Col>
				</Row>
				<Row>
					<div className="suggestions">
						<FilteredActivities data={activityData} type={activitype} />
					</div>
				</Row>
			</div>
		);
	}

	renderWelcome() {
		return (
			<div className="welcome">
				<img src="images/ac_logo.png" alt="Active Cambridge Logo" />
				<h1>What <u>ActiviTYPE</u> are you?</h1>
				<div className="welcome-logos">
					<img src="images/earth.png" alt="Earth symbol" />
					<img src="images/fire.png" alt="Fire symbol" />
					<img src="images/wind.png" alt="Wind symbol" />
					<img src="images/water.png" alt="Water symbol" />
				</div>
				<Button size="lg" color="primary" onClick={() => this.goNextStep()}>Get Started</Button>
			</div>
		);
	}

	renderFinal() {
		return (
			<div>
				<UserProfileForm />
				<Button
					color="primary"
					disabled={!this.allAnswered()}
					onClick={() => { this.goNextStep(); }}
				>
					Calculate ActiviTYPE
				</Button>
			</div>
		);
	}

	renderCurrentStep() {
		const { currentStep } = this.state;
		const steps = this.steps();
		let showProgress = true;
		let content;

		if (steps[currentStep] === 'welcome') {
			content = this.renderWelcome();
			showProgress = false;
		} else if (steps[currentStep] === 'final') {
			content = this.renderFinal();
		} else if (steps[currentStep] === 'results') {
			content = this.renderResults();
			showProgress = false;
		} else {
			content = this.renderQuestion(steps[currentStep]);
		}

		return (
			<div className="text-center">
				{content}
				{ showProgress && (
					<StepProgress current={currentStep} total={steps.length - 2} />
				)}
			</div>
		);
	}

	render() {
		const {
			questionData,
			activityData,
		} = this.state;

		if (!questionData || !activityData) {
			return (<Loader />);
		}

		return (
			<div className="vertical-center">
				<div className="container App">
					{ this.renderCurrentStep() }
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx